import type { Components } from "react-markdown";

import { cn } from "@alaffia-technology-solutions/tailwind-utils";

export const H3: Components["h3"] = ({ children, className, ...rest }) => (
  <h3
    className={cn("af-m-0 af-pt-6 af-text-lg af-font-bold", className)}
    {...rest}
  >
    {children}
  </h3>
);
